const Pill = () => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 138 138"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M48.875 48.875L89.125 89.125M25.875 71.875L71.875 25.875C77.2125 20.5375 84.4516 17.5389 92 17.5389C99.5483 17.5389 106.788 20.5375 112.125 25.875C117.462 31.2125 120.461 38.4517 120.461 46C120.461 53.5483 117.462 60.7875 112.125 66.125L66.125 112.125C60.7875 117.462 53.5483 120.461 46 120.461C38.4516 120.461 31.2125 117.462 25.875 112.125C20.5375 106.788 17.5389 99.5483 17.5389 92C17.5389 84.4517 20.5375 77.2125 25.875 71.875Z"
            stroke="#F5D7B9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Pill;
